import EFPicture from '@elem/compCommon/EFPicture';
import SectionPro from '../components/SectionPro';
import styles from './index.module.scss';

const Reason: React.FC = () => {
    const tableData = {
        thead: [
            {
                img: '',
                title: '',
            },
            {
                img: 'https://websiteoss.ecoflow.com/upload/image/1745219939880/sl_ds%20(1).png',
                title: 'DELTA 2 Max 2048Wh',
            },
            {
                img: 'https://websiteoss.ecoflow.com/upload/image/1745229498494/Frame%201612707420.png',
                title: '他社ポータブル電源',
            },
        ],
        tbody: [
            ['定格出力', '2000W', '2000W'],
            ['サージ出力\n起動時の瞬間的な電力のみ', '4000W', '4000W'],
            ['X-Boost\n連続してその消費電力の家電を使用可能', '最大2400Wの機器を稼働', 'X'],
            ['充電時間\n(0%～80%)', '43分\n※ソーラー + AC充電の場合', '60分'],
            ['充電時間\n(0%～100%)', '1.7時間\n※AC充電の場合', '2時間'],
            ['使用サイクル\n(初期容量の80%を保持)', '3000回＋', '3000回＋'],
            ['容量拡張', '最大6kWh', 'X'],
            ['動作音', '環境音レベル（30dB未満）', 'X'],
            ['保証期間', '5年間', '2年間'],
        ],
    };

    return (
        <div className={`${styles.Reason} GtmModuleData-section`} data-section-id={styles.Reason} data-section-title="DELTA 2 Max が選ばれる理由">
            <SectionPro title="DELTA 2 Max が選ばれる理由">
                <table className="table">
                    <caption></caption>
                    {/* <thead className="thead">
                        <tr className="tr thead-tr"></tr>
                    </thead> */}
                    <tbody className="tbody">
                        <tr className="tr thead-tr">
                            {tableData.thead?.map((head, k) => (
                                <td className="th td" key={k}>
                                    <div className="th_td_wrap">
                                        {head.img && <EFPicture src={head.img} />}
                                        <p className="bold text title">{head?.title}</p>
                                    </div>
                                </td>
                            ))}
                        </tr>
                        {tableData.tbody?.map((row, m) => (
                            <tr className="tr" key={`${m}`}>
                                {row?.map((col, n: number) => (
                                    <td className="td" key={`${m}_${n}td`} width={n === 0 ? '200px' : '400px'}>
                                        {col.split('\n').map((text: string) => {
                                            return <p key={text}>{text}</p>;
                                        })}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </SectionPro>
        </div>
    );
};

export default Reason;
